import React from "react";
import "./Milestones.css";
import Aeroplane from "../../assets/aeroplane.webp";
import Hand from "../../assets/hand.webp";
import Handwhite from "../../assets/hand-white.webp";

const MilestoneItem = ({
  imgSrc,
  imgSize,
  title,
  description,
  isHighlighted,
}) => {
  return (
    <div className="milestone-item">
      <div
        className={`milestone-circle ${isHighlighted ? "highlighted" : ""}`}
        style={{ backgroundColor: isHighlighted ? "#512973" : "transparent" }}
      >
        <img
          src={imgSrc}
          alt={title}
          style={{ width: imgSize.width, height: imgSize.height }}
        />
      </div>
      <p className="milestone-title">{title}</p>
      <p className="milestone-description">{description}</p>
    </div>
  );
};

const Milestones = () => {
  return (
    <div className="milestones-container">
      <MilestoneItem
        imgSrc={Aeroplane}
        imgSize={{ width: "35px", height: "60px" }}
        title="Launched"
        description="2023"
        isHighlighted={false}
      />
      <MilestoneItem
        imgSrc={Handwhite}
        imgSize={{ width: "70px", height: "70px" }}
        title="Capital Commitment"
        description="INR 675 Cr till date"
        isHighlighted={true}
      />
      <MilestoneItem
        imgSrc={Hand}
        imgSize={{ width: "70px", height: "60px" }}
        title="Leadership Experience"
        description={
          <>
            <span>
              of Over
            </span>{" "}
            100 Years
          </>
        }
        isHighlighted={false}
      />
    </div>
  );
};

export default Milestones;
